import React from 'react';
import PropTypes from 'prop-types';
import { mergeStyles } from '@fluentui/react';
import { DefaultButton as FluentDefaultButton, PrimaryButton as FluentPrimaryButton } from '@fluentui/react/lib/Button';
import classNames from 'classnames';

const buttonStyles = mergeStyles({
  width: 96,
  height: 32,
});

const withCustomStyle = (Component) => {
  const ComponentWithStyles = (props) => {
    const { className } = props;
    return (
      <>
        <Component {...props} className={classNames(className, buttonStyles)} />
      </>
    );
  };

  ComponentWithStyles.propTypes = {
    className: PropTypes.string,
  };

  ComponentWithStyles.defaultProps = {
    className: null,
  };

  return ComponentWithStyles;
};

export const DefaultButton = withCustomStyle(FluentDefaultButton);
export const PrimaryButton = withCustomStyle(FluentPrimaryButton);
